import { IState } from 'shared/store';
import { IFeatures } from 'shared/types/features';

export const selectFeatures = (state: IState): IFeatures[] | null => state.offerData.features;
